module.exports = __webpack_public_path__ + "img/N234-1.39e17f37.png";